/* ------------------------------------------------------------------------ */
/*		File: FAQ.tsx                                                       */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React, { useEffect, useState } from "react";
import { CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";
import { ICmpFAQ } from "./cmpFAQ.d";
import "./cmpFAQ.css"
import Popup from "../cmpPopup/cmpPopup";
import Policy from "../cmpPolicy/cmpPolicy";

/* ------------------------------------------------------------------------ */

const Faq: React.FC<ICmpFAQ> = (props) => {
    const { t } = useTranslation();

    const infoRefund:any = t("refund", { returnObjects: true });
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [isOpenRefund, setIsOpenRefund] = useState(false); 

    const togglePopupRefund = () => { setIsOpenRefund(!isOpenRefund) };

    const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const popup = () => {
        togglePopupRefund();
    };

    useEffect(() => {
        const links = document.querySelectorAll('.popup-link');
          if (links.length > 0) {
            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    e.preventDefault();
                    popup();
                });
            });
        }

        // Cleanup event listeners on unmount
        return () => {
            links.forEach(link => {
                link.removeEventListener('click', (e) => {
                    e.preventDefault();
                    popup();
                });
            });
        };
    }, [props.questions, openIndex]);


    return (
        <div className="card_faq">
            <>
            {props.questions?.map((item, index) => (
                <React.Fragment key={`question-${index}`}>
                    <button  
                        className="card_faq_question"
                        onMouseOver={() => toggle(index)}
                    >
                        <div className={openIndex === index ? "yellow" : "blue"}/>
                        <div className="text_question">{item.question}</div>
                        <div className={openIndex === index ? "icon_up" : "icon_down"}></div>
                    </button>
                    <CSSTransition
                        in={openIndex === index}
                        timeout={400}
                        classNames="collapse"
                        unmountOnExit
                    >
                        <div 
                            className="card_faq_answer"
                            dangerouslySetInnerHTML={{ __html: item.answer! }}  
                        />
                    </CSSTransition>
                </React.Fragment>
            ))}
            </>
            {isOpenRefund && ( 
                <Popup 
                    content={
                        <Policy 
                            card={infoRefund} 
                        />
                    }
                    type="refund"
                    popupOptions={undefined}
                    handleClose={togglePopupRefund}
                />
            )}
            
        </div>
    );
};
export default Faq; 